import gsap from 'gsap';
import { getOffsetTop } from '../utils/dom';

const header = document.querySelector('.js-header');

export default function scrollTo(el: Element) {
    const y = getOffsetTop(el) - (header?.getBoundingClientRect().height || 0);
    gsap.to(window, { duration: 0, scrollTo: y, ease: 'easeOutExpo' });
}
